function firstQuery(value) {
  if (Array.isArray(value)) {
    return value[0] ?? null;
  }
  return value ?? null;
}

export function getPolicyId(route) {
  return (
    firstQuery(route?.query?.id) ||
    firstQuery(route?.query?.policyId) ||
    route?.params?.id ||
    route?.params?.policyId ||
    null
  );
}

export function getCardId(route) {
  return (
    firstQuery(route?.query?.cardId) ||
    route?.params?.id ||
    route?.params?.cardId ||
    null
  );
}

export function getRouteSection(route) {
  const path = route?.path || "";
  return path.split("/").filter(Boolean)[0] || "";
}

export function policyUrl(id) {
  return id ? { path: "/policy", query: { id: String(id) } } : { path: "/policy" };
}

export function requestUrl(id) {
  return id ? { path: "/request", query: { id: String(id) } } : { path: "/request" };
}

export function groupClinicUrl(id) {
  return id
    ? { path: "/group-clinic", query: { id: String(id) } }
    : { path: "/group-clinic" };
}

export function filesUrl(id) {
  return id ? { path: "/files", query: { id: String(id) } } : { path: "/files" };
}

export function insuredUrl(cardId, policyId) {
  const query = {};
  if (cardId != null && cardId !== "") {
    query.cardId = String(cardId);
  }
  if (policyId != null && policyId !== "") {
    query.policyId = String(policyId);
  }
  return { path: "/claim/insured", query };
}

export function insuredHref(cardId, policyId) {
  const location = insuredUrl(cardId, policyId);
  const params = new URLSearchParams(location.query).toString();
  return params ? `${location.path}?${params}` : location.path;
}

export function policyHref(id) {
  return id ? `/policy?id=${encodeURIComponent(id)}` : "/policy";
}

export function requestHref(id) {
  return id ? `/request?id=${encodeURIComponent(id)}` : "/request";
}

export function groupClinicHref(id) {
  return id ? `/group-clinic?id=${encodeURIComponent(id)}` : "/group-clinic";
}

export function filesHref(id) {
  return id ? `/files?id=${encodeURIComponent(id)}` : "/files";
}

export function signInUrl(returnPath) {
  if (!returnPath || returnPath === "/" || returnPath.startsWith("/signIn")) {
    return { path: "/signIn" };
  }
  return { path: "/signIn", query: { return: returnPath } };
}

export function resolveReturnPath(route) {
  const fromQuery = firstQuery(route?.query?.return);
  if (fromQuery) {
    return fromQuery.startsWith("/") ? fromQuery : `/${fromQuery}`;
  }
  return "/home";
}

export function currentFullPath(route) {
  if (!route) {
    return "/home";
  }
  return route.fullPath || route.path || "/home";
}
